import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import './assets/style/glabol.scss'
import App from './App.vue'
import router from './routers'
import message from '@/utils/message'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
const app = createApp(App)

app.config.globalProperties.$message = message
app.provide('$message', message)

app.use(router)
   .use(ElementPlus, { locale: zhCn })
   .mount('#app')
